"use client";
import {
  Box,
  Button,
  Container,
  Flex,
  Group,
  Image,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { useMediaQuery } from "usehooks-ts";
import { Tag } from "../../helpers/tag/tag";
import styles from "./card1.module.scss";
import variables from "../../../styles/variables.module.scss";
import useTrans from "@/hooks/useTrans";
import { useEffect, useRef, useState } from "react";

export default function Card1({
  title,
  salary,
  location,
  expirationDate,
  tags,
  showButton = true,
  onBtnClick,
  // threshold,
  image,
  defaultImage,
  hideImage = false,
}) {
  const containerRef = useRef(null);
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        setIsNarrow(width < 768);
      }
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  const trans = useTrans();
  // const isThreshold = useMediaQuery(`(max-width:${threshold || 768}px`);
  const isHotJob =
    Array.isArray(tags) && tags.some((tag) => tag.toLowerCase() === "hot job");

  const filteredTags = tags.filter((tag) => tag.toLowerCase() !== "hot job");
  return (
    <Box className={styles.cardContainer} ref={containerRef}>
      <Group
        noWrap
        align="center"
        w={"100%"}
        h={"100%"}
        style={{
          justifyContent: "space-between",
          alignItems: isNarrow ? "flex-start" : "center",
          display: "flex",
          flexDirection: isNarrow ? "column" : "row",
        }}
      >
        <Group spacing={24} noWrap w={"100%"}>
          {!hideImage && (
            <Image
              src={image ?? defaultImage}
              alt=""
              width={180}
              height={120}
              radius={8}
            />
          )}
          <Stack spacing={12}>
            <Tooltip withArrow label={title}>
              <Text
                fz={20}
                fw={700}
                lh={"28px"}
                lineClamp={4}
                c={variables.primaryColor}
              >
                {title}
              </Text>
            </Tooltip>
            <Group spacing={16}>
              {isHotJob && <Tag type="hotJob" />}
              {filteredTags.map((tag, index) => {
                return (
                  <Group spacing={4} key={index} align="center">
                    <Image
                      alt="icon dollar"
                      src={`${
                        process.env.NEXT_PUBLIC_BASE_PATH
                          ? `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/tags.svg`
                          : `/icons/tags.svg`
                      }`}
                      width={16}
                      height={16}
                    />
                    <Text c={"#0154A4"} fz={14} fw={400} lh={"24px"}>
                      {tag}
                    </Text>
                  </Group>
                );
              })}
              <Group spacing={4}>
                <Image
                  alt="icon dollar"
                  src={`${
                    process.env.NEXT_PUBLIC_BASE_PATH
                      ? `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/dollar.svg`
                      : `/icons/dollar.svg`
                  }`}
                  width={16}
                  height={16}
                />
                <Text fz={14} fw={400} lh={"24px"}>
                  {salary ?? trans.salary}
                </Text>
              </Group>
              <Group spacing={4}>
                <Image
                  alt="icon dollar"
                  src={`${
                    process.env.NEXT_PUBLIC_BASE_PATH
                      ? `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/clock.svg`
                      : `/icons/clock.svg`
                  }`}
                  width={16}
                  height={16}
                />
                <Text fz={14} fw={400} lh={"24px"}>
                  {expirationDate}
                </Text>
              </Group>
              {location && (
                <Tooltip label={location}>
                  <Flex spacing={4} align={"center"} gap={4} wrap="nowrap">
                    <Image
                      alt="icon dollar"
                      src={`${
                        process.env.NEXT_PUBLIC_BASE_PATH
                          ? `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/location-alt.svg`
                          : `/icons/location-alt.svg`
                      }`}
                      width={16}
                      height={16}
                    />
                    <Text lineClamp={1} fz={14} fw={400} lh={"24px"}>
                      {location}
                    </Text>
                  </Flex>
                </Tooltip>
              )}
            </Group>
          </Stack>
        </Group>
        {showButton && (
          <Flex w={isNarrow ? "100%" : "auto"} direction={"row-reverse"}>
            <Button
              className={styles.btnApply}
              w={180}
              radius={"md"}
              onClick={onBtnClick}
            >
              {trans.jobDetail}
            </Button>
          </Flex>
        )}
      </Group>
    </Box>
  );
}
